import { Enum } from './Enum';

export default new Enum({
    NAO_DEFINIDO: { value: 0, text: ' ' },
    PLANEJADO: { value: 1, text: 'Planejado' },
    EM_ANDAMENTO: { value: 2, text: 'Em Andamento' },
    FINALIZADO: { value: 3, text: 'Finalizado' },
    CANCELADO: { value: 7, text: 'Cancelado' }
});
